import { render } from "./AppSlider.vue?vue&type=template&id=245c1095&bindings={\"items\":\"props\",\"key\":\"props\",\"hideCarets\":\"props\"}"
import script from "./AppSlider.vue?vue&type=script&lang=js"
export * from "./AppSlider.vue?vue&type=script&lang=js"
script.render = render

export default script